import src from "IMAGE";
export default { src, width: 473, height: 84, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADEwMDg4MzE7OzU0PzMsKjRAHhI4OBYKMyckKl1BHhNPZggGB+OsBWIAAAAASUVORK5CYII="};
